import $ from 'cash-dom';

const FAQ = {
	$faq: $('#faq'),

	init() {
		if (this.$faq.length && this.$faq.hasClass('open-first-answer')) {
			this.$faq.find('.accordion.first .accordion-title').trigger('click');
		}
	}
}

$(function() {
	FAQ.init();
});
